module.exports = __webpack_public_path__ + "static/img/btn_twitter.b30ce0d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/btn_twitter.svg
// module id = 70
// module chunks = 0